// Home-page comparison grid — same models, same order, as the /models
// page's LLM table (data/arenaModels.js's CURATED_LLMS). LLMs only, on
// purpose: every card below claims LIQUIDBRAIN_ROW's "Unlimited context ·
// Unlimited tokens", which is a token-generation claim an image, vision, or
// voice model doesn't share the same way — see /models for the full
// catalog broken out by modality (data/arenaModels.js's CURATED_IMAGE/
// CURATED_VISION/CURATED_VOICE). `maker` matches the keys in
// components/models/ModelLogo.jsx's LOGO_BY_MAKER map — both the home-page
// grid and the /models table resolve logos through that single lookup.
export const MODEL_GRID = [
  { name: 'Kimi 3', maker: 'Moonshot' },
  { name: 'GLM 5.2 Max', maker: 'Z.ai' },
  { name: 'MiniMax M3', maker: 'MiniMax' },
  { name: 'DeepSeek V4 Pro', maker: 'DeepSeek' },
  { name: 'DeepSeek V4 Flash', maker: 'DeepSeek' },
  { name: 'Qwen 3.6 27B', maker: 'Alibaba' },
  { name: 'Muse Glimmer', maker: 'Meta' },
  { name: 'Gemma 4 31B', maker: 'Google' },
  { name: 'Qwen 3.8 Max', maker: 'Alibaba', soon: true },
]

// Fixed for every row — LiquidBrain's guarantee never varies by model.
export const LIQUIDBRAIN_ROW = 'Unlimited context · Unlimited tokens'
